import React from "react";
import { Box } from "@mui/joy";

type Props = {
  enabled: boolean;
  fallback: React.ReactNode;
  children: React.ReactNode;
};

export default function TrainingListRowGuard({ enabled, fallback, children }: Props) {
  return <Box sx={{ display: "inline-flex" }}>{enabled ? children : fallback}</Box>;
}
